(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './curity-ssi-libs-jose.js', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js', './curity-ssi-libs-core.js', './curity-ssi-libs-core-json.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./curity-ssi-libs-jose.js'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./curity-ssi-libs-core.js'), require('./curity-ssi-libs-core-json.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'));
  else {
    if (typeof this['curity-ssi-libs-jose'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'curity-ssi-libs-jose' was not found. Please, check whether 'curity-ssi-libs-jose' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    if (typeof this['curity-ssi-libs-core-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'curity-ssi-libs-core-json' was not found. Please, check whether 'curity-ssi-libs-core-json' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-sd-jwt'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'curity-ssi-libs-sd-jwt'.");
    }
    root['curity-ssi-libs-sd-jwt'] = factory(typeof this['curity-ssi-libs-sd-jwt'] === 'undefined' ? {} : this['curity-ssi-libs-sd-jwt'], this['curity-ssi-libs-jose'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core'], this['curity-ssi-libs-core'], this['curity-ssi-libs-core-json'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir']);
  }
}(globalThis, function (_, kotlin_io_curity_ssi_jose, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_curity_ssi_core, kotlin_io_curity_ssi_core_json, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var secureRandom = kotlin_io_curity_ssi_jose.$_$.p;
  var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var CoroutineImpl = kotlin_kotlin.$_$.n9;
  var encodeToByteArray = kotlin_kotlin.$_$.nc;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var listOf = kotlin_kotlin.$_$.o7;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var isInterface = kotlin_kotlin.$_$.xa;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var VOID = kotlin_kotlin.$_$.f;
  var decodeBase64Url = kotlin_io_curity_ssi_jose.$_$.n;
  var decodeToString = kotlin_kotlin.$_$.mc;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.t1;
  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var IllegalArgumentException = kotlin_kotlin.$_$.le;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var initMetadataForInterface = kotlin_kotlin.$_$.ma;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var mapCapacity = kotlin_kotlin.$_$.p7;
  var coerceAtLeast = kotlin_kotlin.$_$.rb;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
  var Triple = kotlin_kotlin.$_$.ve;
  var Pair = kotlin_kotlin.$_$.qe;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var toString = kotlin_kotlin.$_$.vf;
  var toString_0 = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.ha;
  var equals = kotlin_kotlin.$_$.ba;
  var StringBuilder = kotlin_kotlin.$_$.hc;
  var split = kotlin_kotlin.$_$.gd;
  var Companion_instance = kotlin_io_curity_ssi_core.$_$.c;
  var charSequenceLength = kotlin_kotlin.$_$.x9;
  var get_lastIndex = kotlin_kotlin.$_$.j7;
  var until = kotlin_kotlin.$_$.yb;
  var slice = kotlin_kotlin.$_$.f8;
  var isBlank = kotlin_kotlin.$_$.uc;
  var createHashFunction = kotlin_io_curity_ssi_jose.$_$.m;
  var sha256 = kotlin_io_curity_ssi_jose.$_$.q;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var toMutableMap = kotlin_kotlin.$_$.p8;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var toList = kotlin_kotlin.$_$.k8;
  var to = kotlin_kotlin.$_$.wf;
  var toMap = kotlin_kotlin.$_$.n8;
  var checkIndexOverflow = kotlin_kotlin.$_$.z5;
  var mapOf = kotlin_kotlin.$_$.q7;
  var JsonJwsHeader = kotlin_io_curity_ssi_jose.$_$.s;
  var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
  var mapOf_0 = kotlin_kotlin.$_$.r7;
  var JsonJwtClaimsSet = kotlin_io_curity_ssi_jose.$_$.u;
  var JwsUtil_getInstance = kotlin_io_curity_ssi_jose.$_$.j;
  var Jws = kotlin_io_curity_ssi_jose.$_$.t;
  var initMetadataForLambda = kotlin_kotlin.$_$.na;
  var ValidationException_init_$Create$ = kotlin_io_curity_ssi_core.$_$.b;
  var contentEquals = kotlin_kotlin.$_$.lc;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
  var JsonNull_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var singleOrNull = kotlin_kotlin.$_$.e8;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var JsonPrimitiveSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var contentEquals_0 = kotlin_kotlin.$_$.c6;
  var contentHashCode = kotlin_kotlin.$_$.d6;
  var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var setOf = kotlin_kotlin.$_$.b8;
  var Companion_getInstance = kotlin_io_curity_ssi_jose.$_$.g;
  var Companion_instance_0 = kotlin_io_curity_ssi_jose.$_$.e;
  var fromJwkDictionary = kotlin_io_curity_ssi_jose.$_$.c;
  var Exception = kotlin_kotlin.$_$.ke;
  var $serializer_getInstance = kotlin_io_curity_ssi_jose.$_$.h;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var get_intOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
  var get_booleanOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.o;
  var get_doubleOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.p;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var Collection = kotlin_kotlin.$_$.j5;
  var JsToJsonConverter_instance = kotlin_io_curity_ssi_core_json.$_$.c;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var JsonToJsConverter_instance = kotlin_io_curity_ssi_core_json.$_$.d;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForCompanion(Companion_0);
  initMetadataForCoroutine($hashDisclosureCOROUTINE$0, CoroutineImpl);
  function toDisclosureHashString(hashFunction, $completion) {
    return Companion_instance_3.k2l(hashFunction, this.f2l(), $completion);
  }
  initMetadataForInterface(Disclosure, 'Disclosure', VOID, VOID, VOID, [1]);
  initMetadataForClass(Property, 'Property', VOID, VOID, [Disclosure], [1]);
  initMetadataForClass(Value, 'Value', VOID, VOID, [Disclosure], [1]);
  initMetadataForCompanion(Companion_1, VOID, VOID, [2]);
  initMetadataForCoroutine($createCOROUTINE$1, CoroutineImpl);
  initMetadataForCompanion(Companion_2, VOID, VOID, [3]);
  initMetadataForClass(DisclosuresByHash, 'DisclosuresByHash');
  initMetadataForClass(Property_0, 'Property');
  initMetadataForClass(ArrayIndex, 'ArrayIndex');
  initMetadataForObject(AnyProperty, 'AnyProperty');
  initMetadataForObject(AnyIndex, 'AnyIndex');
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(JsonPath, 'JsonPath');
  initMetadataForCoroutine($computeKbJwtSdHashCOROUTINE$2, CoroutineImpl);
  initMetadataForCompanion(Companion_4, VOID, VOID, [3]);
  initMetadataForClass(Decoded, 'Decoded');
  initMetadataForClass(SdJwt, 'SdJwt');
  initMetadataForClass(Result, 'Result');
  initMetadataForCompanion(Companion_5);
  initMetadataForCoroutine($concealCOROUTINE$3, CoroutineImpl);
  initMetadataForCoroutine($concealElementCOROUTINE$5, CoroutineImpl);
  initMetadataForCoroutine($concealObjectCOROUTINE$6, CoroutineImpl);
  initMetadataForCoroutine($concealArrayCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(SdJwtConcealer, 'SdJwtConcealer', VOID, VOID, VOID, [1, 2, 3]);
  initMetadataForCoroutine($buildCOROUTINE$8, CoroutineImpl);
  initMetadataForObject(SdJwtKeyBindingBuilder, 'SdJwtKeyBindingBuilder', VOID, VOID, VOID, [8]);
  initMetadataForLambda(SdJwtParser$Companion$decodeFromString$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($decodeFromStringCOROUTINE$13, CoroutineImpl);
  initMetadataForCompanion(Companion_6, VOID, VOID, [3, 4]);
  initMetadataForCoroutine($discloseCOROUTINE$10, CoroutineImpl);
  initMetadataForCoroutine($discloseCOROUTINE$11, CoroutineImpl);
  initMetadataForCoroutine($discloseCOROUTINE$12, CoroutineImpl);
  initMetadataForClass(SdJwtParser, 'SdJwtParser', VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_8);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(SdValue, 'SdValue', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
  initMetadataForClass(Object_0, 'Object', VOID, VOID, [SdValue], VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForClass(Array_0, 'Array', VOID, VOID, [SdValue], VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForClass(Primitive, 'Primitive', VOID, VOID, [SdValue], VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForCompanion(Companion_10, VOID, [SerializerFactory]);
  initMetadataForCompanion(Companion_11);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SdProperty, 'SdProperty', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_12);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SdArrayValue, 'SdArrayValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForClass(Result_0, 'Result');
  initMetadataForClass(ValidatedPayload, 'ValidatedPayload');
  initMetadataForCoroutine($validateIssuerJwtCOROUTINE$15, CoroutineImpl);
  initMetadataForCoroutine($validateJwtSignatureCOROUTINE$16, CoroutineImpl);
  initMetadataForClass(VcSdJwtIssuerJwtValidator, 'VcSdJwtIssuerJwtValidator', VOID, VOID, VOID, [3]);
  initMetadataForCompanion(Companion_13);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonVcSdJwtIssuerMetadata, 'JsonVcSdJwtIssuerMetadata', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForClass(SdJwtParseResult, 'SdJwtParseResult');
  initMetadataForInterface(SdValue_0, 'SdValue');
  initMetadataForClass(SdObject, 'SdObject', VOID, VOID, [SdValue_0]);
  initMetadataForClass(SdArray, 'SdArray', VOID, VOID, [SdValue_0]);
  initMetadataForClass(SdPrimitive, 'SdPrimitive', VOID, VOID, [SdValue_0]);
  initMetadataForClass(SdArrayValue_0, 'SdArrayValue');
  initMetadataForClass(SdProperty_0, 'SdProperty');
  initMetadataForClass(ConcealResult, 'ConcealResult');
  initMetadataForLambda(parseSdJwt$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(parseSdJwt$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(concealSdJwt$slambda, CoroutineImpl, VOID, [1]);
  //endregion
  function Companion() {
  }
  protoOf(Companion).p2k = function (name, value) {
    return new Property(encodeBase64url(secureRandom(32)), name, value);
  };
  var Companion_instance_1;
  function Companion_getInstance_0() {
    return Companion_instance_1;
  }
  function Companion_0() {
  }
  protoOf(Companion_0).q2k = function (value) {
    return new Value(secureRandom(32), value);
  };
  var Companion_instance_2;
  function Companion_getInstance_1() {
    return Companion_instance_2;
  }
  function $hashDisclosureCOROUTINE$0(_this__u8e3s4, hashFunction, disclosure, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z2k_1 = _this__u8e3s4;
    this.a2l_1 = hashFunction;
    this.b2l_1 = disclosure;
  }
  protoOf($hashDisclosureCOROUTINE$0).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.a2l_1(encodeToByteArray(this.b2l_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return encodeBase64url(ARGUMENT);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Property(salt, name, value) {
    this.c2l_1 = salt;
    this.d2l_1 = name;
    this.e2l_1 = value;
  }
  protoOf(Property).f2l = function () {
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    var value = new JsonArray(listOf([JsonPrimitive(this.c2l_1), JsonPrimitive(this.d2l_1), this.e2l_1]));
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JsonArray), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    return encodeBase64url(encodeToByteArray(tmp$ret$2));
  };
  function Value(salt, value) {
    this.h2l_1 = salt;
    this.i2l_1 = value;
  }
  protoOf(Value).f2l = function () {
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    var value = new JsonArray(listOf([JsonPrimitive(encodeBase64url(this.h2l_1)), this.i2l_1]));
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JsonArray), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    return encodeBase64url(encodeToByteArray(tmp$ret$2));
  };
  function Companion_1() {
  }
  protoOf(Companion_1).j2l = function (disclosure, json) {
    var decodedDisclosure = decodeBase64Url(disclosure);
    var tmp;
    try {
      tmp = json.c19(decodeToString(decodedDisclosure));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof SerializationException) {
        var ex = $p;
        throw IllegalArgumentException_init_$Create$('Disclosure has bad format', ex);
      } else {
        throw $p;
      }
    }
    var jsonElement = tmp;
    if (!(jsonElement instanceof JsonArray)) {
      throw IllegalArgumentException_init_$Create$_0('Disclosure must be an array');
    }
    var containsArg = jsonElement.m();
    if (!(2 <= containsArg ? containsArg <= 3 : false)) {
      throw IllegalArgumentException_init_$Create$_0('Disclosure must contain two or three elements');
    }
    var salt = jsonElement.o(0);
    var tmp_1;
    if (!(salt instanceof JsonPrimitive_0)) {
      tmp_1 = true;
    } else {
      tmp_1 = !salt.d1b();
    }
    if (tmp_1) {
      throw IllegalArgumentException_init_$Create$_0('Disclosure has bad format: salt is not a string');
    }
    var tmp_2;
    try {
      tmp_2 = decodeBase64Url(salt.e1b());
    } catch ($p) {
      var tmp_3;
      if ($p instanceof IllegalArgumentException) {
        var ex_0 = $p;
        throw IllegalArgumentException_init_$Create$_0('Disclosure has bad format: salt is not correctly encoded');
      } else {
        throw $p;
      }
    }
    var decodedSalt = tmp_2;
    if (decodedSalt.length < 8) {
      throw IllegalArgumentException_init_$Create$_0('Disclosure has bad format: salt is too small');
    }
    if (jsonElement.m() === 2) {
      var value = jsonElement.o(1);
      return new Value(decodedSalt, value);
    }
    if (jsonElement.m() === 3) {
      var name = jsonElement.o(1);
      var value_0 = jsonElement.o(2);
      var tmp_4;
      if (!(name instanceof JsonPrimitive_0)) {
        tmp_4 = true;
      } else {
        tmp_4 = !name.d1b();
      }
      if (tmp_4) {
        throw IllegalArgumentException_init_$Create$_0('Disclosure has bad format: name must be a string');
      }
      return new Property(salt.e1b(), name.e1b(), value_0);
    }
    throw IllegalArgumentException_init_$Create$_0('Disclosure must contain two or three elements');
  };
  protoOf(Companion_1).k2l = function (hashFunction, disclosure, $completion) {
    var tmp = new $hashDisclosureCOROUTINE$0(this, hashFunction, disclosure, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_3;
  function Companion_getInstance_2() {
    return Companion_instance_3;
  }
  function Disclosure() {
  }
  function $createCOROUTINE$1(_this__u8e3s4, disclosureStrings, hashFunction, json, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t2l_1 = _this__u8e3s4;
    this.u2l_1 = disclosureStrings;
    this.v2l_1 = hashFunction;
    this.w2l_1 = json;
  }
  protoOf($createCOROUTINE$1).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            var tmp_0 = this;
            tmp_0.x2l_1 = this.u2l_1;
            this.y2l_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this.x2l_1, 10)), 16);
            var tmp_1 = this;
            tmp_1.z2l_1 = this.x2l_1;
            var tmp_2 = this;
            tmp_2.a2m_1 = LinkedHashMap_init_$Create$(this.y2l_1);
            this.b2m_1 = this.z2l_1.j();
            this.v8_1 = 1;
            continue $sm;
          case 1:
            if (!this.b2m_1.k()) {
              this.v8_1 = 3;
              continue $sm;
            }

            this.c2m_1 = this.b2m_1.l();
            var tmp_3 = this;
            tmp_3.d2m_1 = this.c2m_1;
            this.v8_1 = 2;
            suspendResult = Companion_instance_3.k2l(this.v2l_1, this.d2m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.a2m_1.m2(ARGUMENT, this.c2m_1);
            this.v8_1 = 1;
            continue $sm;
          case 3:
            var ARGUMENT_0 = this.a2m_1;
            return new DisclosuresByHash(ARGUMENT_0, this.w2l_1);
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Companion_2() {
  }
  protoOf(Companion_2).e2m = function (disclosureStrings, hashFunction, json, $completion) {
    var tmp = new $createCOROUTINE$1(this, disclosureStrings, hashFunction, json, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_4;
  function Companion_getInstance_3() {
    return Companion_instance_4;
  }
  function DisclosuresByHash(disclosureStringsByHash, json) {
    this.f2m_1 = disclosureStringsByHash;
    this.g2m_1 = json;
  }
  protoOf(DisclosuresByHash).h2m = function (hash) {
    var tmp0_safe_receiver = this.f2m_1.e2(hash);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.sdjwt.DisclosuresByHash.getProperty.<anonymous>' call
      var disclosure = Companion_instance_3.j2l(tmp0_safe_receiver, this.g2m_1);
      if (!(disclosure instanceof Property)) {
        throw IllegalArgumentException_init_$Create$_0('Property is using a disclosure of the wrong type');
      }
      tmp = new Triple(disclosure.d2l_1, disclosure.e2l_1, tmp0_safe_receiver);
    }
    return tmp;
  };
  protoOf(DisclosuresByHash).i2m = function (hash) {
    var tmp1_safe_receiver = this.f2m_1.e2(hash);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.sdjwt.DisclosuresByHash.getArrayValue.<anonymous>' call
      var disclosure = Companion_instance_3.j2l(tmp1_safe_receiver, this.g2m_1);
      if (!(disclosure instanceof Value)) {
        throw IllegalArgumentException_init_$Create$_0('Array value is using a disclosure of the wrong type');
      }
      tmp = new Pair(disclosure.i2l_1, tmp1_safe_receiver);
    }
    return tmp;
  };
  function Property_0(name) {
    this.j2m_1 = name;
  }
  protoOf(Property_0).k2m = function (other) {
    var tmp;
    if (this.equals(other)) {
      tmp = true;
    } else {
      tmp = other instanceof AnyProperty;
    }
    return tmp;
  };
  protoOf(Property_0).toString = function () {
    return this.j2m_1;
  };
  protoOf(Property_0).hashCode = function () {
    return getStringHashCode(this.j2m_1);
  };
  protoOf(Property_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Property_0))
      return false;
    var tmp0_other_with_cast = other instanceof Property_0 ? other : THROW_CCE();
    if (!(this.j2m_1 === tmp0_other_with_cast.j2m_1))
      return false;
    return true;
  };
  function ArrayIndex(index) {
    this.l2m_1 = index;
  }
  protoOf(ArrayIndex).k2m = function (other) {
    var tmp;
    if (this.equals(other)) {
      tmp = true;
    } else {
      tmp = other instanceof AnyIndex;
    }
    return tmp;
  };
  protoOf(ArrayIndex).toString = function () {
    return '[' + this.l2m_1 + ']';
  };
  protoOf(ArrayIndex).hashCode = function () {
    return this.l2m_1;
  };
  protoOf(ArrayIndex).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ArrayIndex))
      return false;
    var tmp0_other_with_cast = other instanceof ArrayIndex ? other : THROW_CCE();
    if (!(this.l2m_1 === tmp0_other_with_cast.l2m_1))
      return false;
    return true;
  };
  function AnyProperty() {
  }
  protoOf(AnyProperty).k2m = function (other) {
    var tmp;
    if (this.equals(other)) {
      tmp = true;
    } else {
      tmp = other instanceof Property_0;
    }
    return tmp;
  };
  protoOf(AnyProperty).toString = function () {
    return '*';
  };
  protoOf(AnyProperty).hashCode = function () {
    return -362470;
  };
  protoOf(AnyProperty).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnyProperty))
      return false;
    other instanceof AnyProperty || THROW_CCE();
    return true;
  };
  var AnyProperty_instance;
  function AnyProperty_getInstance() {
    return AnyProperty_instance;
  }
  function AnyIndex() {
  }
  protoOf(AnyIndex).k2m = function (other) {
    var tmp;
    if (this.equals(other)) {
      tmp = true;
    } else {
      tmp = other instanceof ArrayIndex;
    }
    return tmp;
  };
  protoOf(AnyIndex).toString = function () {
    return '[*]';
  };
  protoOf(AnyIndex).hashCode = function () {
    return 1972714669;
  };
  protoOf(AnyIndex).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnyIndex))
      return false;
    other instanceof AnyIndex || THROW_CCE();
    return true;
  };
  var AnyIndex_instance;
  function AnyIndex_getInstance() {
    return AnyIndex_instance;
  }
  function buildFromSegments($this, segments) {
    var iterator = segments.j();
    if (!iterator.k()) {
      throw IllegalArgumentException_init_$Create$_0('segment list cannot be empty');
    }
    var current = new JsonPath(iterator.l());
    while (iterator.k()) {
      current = new JsonPath(iterator.l(), current);
    }
    return current;
  }
  function build($this, segment) {
    var tmp;
    if (typeof segment === 'number') {
      tmp = new ArrayIndex(segment);
    } else {
      if (typeof segment === 'string') {
        switch (segment) {
          case '[*]':
            tmp = AnyIndex_instance;
            break;
          case '*':
            tmp = AnyProperty_instance;
            break;
          default:
            tmp = new Property_0(segment);
            break;
        }
      } else {
        throw IllegalArgumentException_init_$Create$_0('segment must be Int or String, however it was ' + getKClassFromExpression(segment).fa());
      }
    }
    return tmp;
  }
  function Companion_3() {
    this.m2m_1 = '[*]';
    this.n2m_1 = '*';
  }
  protoOf(Companion_3).o2m = function (segments) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(segments.length);
    var inductionVariable = 0;
    var last = segments.length;
    while (inductionVariable < last) {
      var item = segments[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'io.curity.ssi.sdjwt.Companion.build.<anonymous>' call
      var tmp$ret$0 = build(Companion_instance_5, item);
      destination.e(tmp$ret$0);
    }
    return buildFromSegments(this, destination);
  };
  var Companion_instance_5;
  function Companion_getInstance_4() {
    return Companion_instance_5;
  }
  function JsonPath(current, previous) {
    previous = previous === VOID ? null : previous;
    this.p2m_1 = current;
    this.q2m_1 = previous;
    var tmp = this;
    var tmp3_safe_receiver = this.q2m_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r2m_1;
    var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver + 1 | 0;
    tmp.r2m_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
  }
  protoOf(JsonPath).toString = function () {
    return this.q2m_1 == null ? '/' + toString_0(this.p2m_1) : toString(this.q2m_1) + '/' + toString_0(this.p2m_1);
  };
  protoOf(JsonPath).s2m = function (segment) {
    return new JsonPath(segment, this);
  };
  protoOf(JsonPath).t2m = function (name) {
    return this.s2m(new Property_0(name));
  };
  protoOf(JsonPath).u2m = function (index) {
    return this.s2m(new ArrayIndex(index));
  };
  protoOf(JsonPath).v2m = function (other) {
    if (!(this.r2m_1 === other.r2m_1)) {
      return false;
    }
    var path1 = this;
    var path2 = other;
    while (!(path1 == null) && !(path2 == null)) {
      if (!path1.p2m_1.k2m(path2.p2m_1)) {
        return false;
      }
      path1 = path1.q2m_1;
      path2 = path2.q2m_1;
    }
    return true;
  };
  protoOf(JsonPath).hashCode = function () {
    var result = hashCode(this.p2m_1);
    result = imul(result, 31) + (this.q2m_1 == null ? 0 : this.q2m_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonPath))
      return false;
    var tmp0_other_with_cast = other instanceof JsonPath ? other : THROW_CCE();
    if (!equals(this.p2m_1, tmp0_other_with_cast.p2m_1))
      return false;
    if (!equals(this.q2m_1, tmp0_other_with_cast.q2m_1))
      return false;
    return true;
  };
  function withProperty(_this__u8e3s4, name) {
    var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.t2m(name);
    return tmp0_elvis_lhs == null ? new JsonPath(new Property_0(name)) : tmp0_elvis_lhs;
  }
  function $computeKbJwtSdHashCOROUTINE$2(_this__u8e3s4, jwt, jwtString, disclosures, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e2n_1 = _this__u8e3s4;
    this.f2n_1 = jwt;
    this.g2n_1 = jwtString;
    this.h2n_1 = disclosures;
  }
  protoOf($computeKbJwtSdHashCOROUTINE$2).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.i2n_1 = this.e2n_1.k2n(this.f2n_1);
            this.j2n_1 = this.e2n_1.l2n(this.g2n_1, this.h2n_1);
            this.v8_1 = 1;
            suspendResult = this.i2n_1(encodeToByteArray(this.j2n_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return encodeBase64url(ARGUMENT);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Companion_4() {
  }
  protoOf(Companion_4).m2n = function (jwtString, disclosureStrings, keyBindingJwtString) {
    var builder = (new StringBuilder(jwtString)).e8('~');
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = disclosureStrings.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.sdjwt.Companion.encode.<anonymous>' call
      builder.e8(element).e8('~');
    }
    if (!(keyBindingJwtString == null)) {
      builder.e8(keyBindingJwtString);
    }
    return builder.toString();
  };
  protoOf(Companion_4).l2n = function (jwtString, disclosureStrings, keyBindingJwtString, $super) {
    keyBindingJwtString = keyBindingJwtString === VOID ? null : keyBindingJwtString;
    return $super === VOID ? this.m2n(jwtString, disclosureStrings, keyBindingJwtString) : $super.m2n.call(this, jwtString, disclosureStrings, keyBindingJwtString);
  };
  protoOf(Companion_4).n2n = function (encodedToken) {
    var parts = split(encodedToken, ['~']);
    if (parts.m() < 2) {
      return Companion_instance.zm("Invalid SD-JWT: missing at least one '~'");
    }
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = parts.o(0);
    if (charSequenceLength(this_0) === 0) {
      return Companion_instance.zm('Invalid SD-JWT: needs to start with a JWT');
    }
    var jwtString = parts.o(0);
    var disclosures = slice(parts, until(1, get_lastIndex(parts)));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.ssi.sdjwt.Companion.decode.<anonymous>' call
    // Inline function 'kotlin.text.ifBlank' call
    var this_1 = parts.o(get_lastIndex(parts));
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (isBlank(this_1)) {
      // Inline function 'io.curity.ssi.sdjwt.Companion.decode.<anonymous>.<anonymous>' call
      tmp = null;
    } else {
      tmp = this_1;
    }
    var keyBindingJwtString = tmp;
    return Companion_instance.an(new Decoded(jwtString, disclosures, keyBindingJwtString));
  };
  protoOf(Companion_4).o2n = function (jwt, jwtString, disclosures, $completion) {
    var tmp = new $computeKbJwtSdHashCOROUTINE$2(this, jwt, jwtString, disclosures, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(Companion_4).k2n = function (jwt) {
    var tmp8_safe_receiver = jwt.k29_1.vl('_sd_alg');
    var tmp;
    if (tmp8_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.sdjwt.Companion.getHashFunctionToUse.<anonymous>' call
      var tmp_0;
      if (!(tmp8_safe_receiver instanceof JsonPrimitive_0)) {
        tmp_0 = true;
      } else {
        tmp_0 = !tmp8_safe_receiver.d1b();
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$_0('Invalid SD-JWT: _sd_alg is not a string');
      }
      var hashAlg = tmp8_safe_receiver.e1b();
      var tmp0_elvis_lhs = createHashFunction(hashAlg);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        throw IllegalArgumentException_init_$Create$_0('Invalid SD-JWT: Unsupported hash algorithm ' + hashAlg + ' ');
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp = tmp_1;
    }
    var tmp0_elvis_lhs_0 = tmp;
    return tmp0_elvis_lhs_0 == null ? sha256() : tmp0_elvis_lhs_0;
  };
  var Companion_instance_6;
  function Companion_getInstance_5() {
    return Companion_instance_6;
  }
  function Decoded(jwt, disclosures, keyBindingJwt) {
    keyBindingJwt = keyBindingJwt === VOID ? null : keyBindingJwt;
    this.p2n_1 = jwt;
    this.q2n_1 = disclosures;
    this.r2n_1 = keyBindingJwt;
  }
  protoOf(Decoded).ba = function () {
    return this.p2n_1;
  };
  protoOf(Decoded).ca = function () {
    return this.q2n_1;
  };
  protoOf(Decoded).qj = function () {
    return this.r2n_1;
  };
  protoOf(Decoded).toString = function () {
    return 'Decoded(jwt=' + this.p2n_1 + ', disclosures=' + toString_0(this.q2n_1) + ', keyBindingJwt=' + this.r2n_1 + ')';
  };
  protoOf(Decoded).hashCode = function () {
    var result = getStringHashCode(this.p2n_1);
    result = imul(result, 31) + hashCode(this.q2n_1) | 0;
    result = imul(result, 31) + (this.r2n_1 == null ? 0 : getStringHashCode(this.r2n_1)) | 0;
    return result;
  };
  protoOf(Decoded).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Decoded))
      return false;
    var tmp0_other_with_cast = other instanceof Decoded ? other : THROW_CCE();
    if (!(this.p2n_1 === tmp0_other_with_cast.p2n_1))
      return false;
    if (!equals(this.q2n_1, tmp0_other_with_cast.q2n_1))
      return false;
    if (!(this.r2n_1 == tmp0_other_with_cast.r2n_1))
      return false;
    return true;
  };
  function SdJwt(jwtString, jwt, disclosedCustomClaims, disclosureStrings, keyBindingJwtString, keyBindingJwt) {
    this.s2n_1 = jwtString;
    this.t2n_1 = jwt;
    this.u2n_1 = disclosedCustomClaims;
    this.v2n_1 = disclosureStrings;
    this.w2n_1 = keyBindingJwtString;
    this.x2n_1 = keyBindingJwt;
  }
  function Result(obj, disclosures) {
    this.y2n_1 = obj;
    this.z2n_1 = disclosures;
  }
  protoOf(Result).toString = function () {
    return 'Result(obj=' + toString(this.y2n_1) + ', disclosures=' + toString_0(this.z2n_1) + ')';
  };
  protoOf(Result).hashCode = function () {
    var result = this.y2n_1 == null ? 0 : hashCode(this.y2n_1);
    result = imul(result, 31) + hashCode(this.z2n_1) | 0;
    return result;
  };
  protoOf(Result).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.y2n_1, tmp0_other_with_cast.y2n_1))
      return false;
    if (!equals(this.z2n_1, tmp0_other_with_cast.z2n_1))
      return false;
    return true;
  };
  function concealElement($this, element, disclosures, path, $completion) {
    var tmp = new $concealElementCOROUTINE$5($this, element, disclosures, path, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function concealObject($this, obj, disclosures, path, $completion) {
    var tmp = new $concealObjectCOROUTINE$6($this, obj, disclosures, path, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function concealArray($this, array, disclosures, path, $completion) {
    var tmp = new $concealArrayCOROUTINE$7($this, array, disclosures, path, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function Companion_5() {
  }
  var Companion_instance_7;
  function Companion_getInstance_6() {
    return Companion_instance_7;
  }
  function $concealCOROUTINE$3(_this__u8e3s4, obj, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s2q_1 = _this__u8e3s4;
    this.t2q_1 = obj;
  }
  protoOf($concealCOROUTINE$3).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            var tmp_0 = this;
            tmp_0.u2q_1 = ArrayList_init_$Create$_0();
            var tmp_1 = this;
            var this_0 = toMutableMap(this.t2q_1);
            var value = JsonPrimitive(this.s2q_1.w2q_1);
            this_0.m2('_sd_alg', value);
            tmp_1.v2q_1 = this_0;
            this.v8_1 = 1;
            suspendResult = concealObject(this.s2q_1, new JsonObject(this.v2q_1), this.u2q_1, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var concealedObject = suspendResult;
            return new Result(concealedObject, toList(this.u2q_1));
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $concealElementCOROUTINE$5(_this__u8e3s4, element, disclosures, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i2o_1 = _this__u8e3s4;
    this.j2o_1 = element;
    this.k2o_1 = disclosures;
    this.l2o_1 = path;
  }
  protoOf($concealElementCOROUTINE$5).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.m2o_1 = this.j2o_1;
            var tmp_0 = this.m2o_1;
            if (tmp_0 instanceof JsonObject) {
              this.v8_1 = 2;
              suspendResult = concealObject(this.i2o_1, this.j2o_1, this.k2o_1, this.l2o_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.m2o_1;
              if (tmp_1 instanceof JsonArray) {
                this.v8_1 = 1;
                suspendResult = concealArray(this.i2o_1, this.j2o_1, this.k2o_1, this.l2o_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n2o_1 = this.j2o_1;
                this.v8_1 = 3;
                continue $sm;
              }
            }

          case 1:
            this.n2o_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.n2o_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            return this.n2o_1;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $concealObjectCOROUTINE$6(_this__u8e3s4, obj, disclosures, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w2o_1 = _this__u8e3s4;
    this.x2o_1 = obj;
    this.y2o_1 = disclosures;
    this.z2o_1 = path;
  }
  protoOf($concealObjectCOROUTINE$6).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            var tmp_0 = this;
            tmp_0.a2p_1 = ArrayList_init_$Create$_0();
            var tmp_1 = this;
            tmp_1.b2p_1 = ArrayList_init_$Create$_0();
            var tmp_2 = this;
            tmp_2.c2p_1 = this.x2o_1.z();
            this.d2p_1 = this.c2p_1.j();
            this.v8_1 = 1;
            continue $sm;
          case 1:
            if (!this.d2p_1.k()) {
              this.v8_1 = 5;
              continue $sm;
            }

            this.e2p_1 = this.d2p_1.l();
            var tmp_3 = this;
            tmp_3.f2p_1 = this.e2p_1;
            var tmp_4 = this;
            tmp_4.g2p_1 = this.f2p_1.a1();
            var tmp_5 = this;
            tmp_5.h2p_1 = this.f2p_1.b1();
            this.i2p_1 = withProperty(this.z2o_1, this.g2p_1);
            this.v8_1 = 2;
            suspendResult = concealElement(this.w2o_1, this.h2p_1, this.y2o_1, this.i2p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.j2p_1 = suspendResult;
            if (this.w2o_1.y2q_1(this.i2p_1, this.h2p_1)) {
              this.l2p_1 = Companion_instance_1.p2k(this.g2p_1, this.j2p_1);
              this.y2o_1.e(this.l2p_1);
              this.v8_1 = 3;
              suspendResult = this.l2p_1.g2l(this.w2o_1.x2q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_6 = this;
              tmp_6.k2p_1 = this.a2p_1.e(to(this.g2p_1, this.j2p_1));
              this.v8_1 = 4;
              continue $sm;
            }

          case 3:
            var ARGUMENT = suspendResult;
            this.k2p_1 = this.b2p_1.e(ARGUMENT);
            this.v8_1 = 4;
            continue $sm;
          case 4:
            this.v8_1 = 1;
            continue $sm;
          case 5:
            if (!this.b2p_1.s()) {
              var this_0 = this.b2p_1;
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
              var tmp0_iterator = this_0.j();
              while (tmp0_iterator.k()) {
                var item = tmp0_iterator.l();
                destination.e(JsonPrimitive(item));
              }
              this.a2p_1.e(to('_sd', new JsonArray(destination)));
            }

            return new JsonObject(toMap(this.a2p_1));
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $concealArrayCOROUTINE$7(_this__u8e3s4, array, disclosures, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u2p_1 = _this__u8e3s4;
    this.v2p_1 = array;
    this.w2p_1 = disclosures;
    this.x2p_1 = path;
  }
  protoOf($concealArrayCOROUTINE$7).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            var tmp_0 = this;
            tmp_0.y2p_1 = this.v2p_1;
            var tmp_1 = this;
            tmp_1.z2p_1 = this.y2p_1;
            var tmp_2 = this;
            tmp_2.a2q_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this.y2p_1, 10));
            this.b2q_1 = 0;
            this.c2q_1 = this.z2p_1.j();
            this.v8_1 = 1;
            continue $sm;
          case 1:
            if (!this.c2q_1.k()) {
              this.v8_1 = 5;
              continue $sm;
            }

            this.d2q_1 = this.c2q_1.l();
            var tmp_3 = this;
            var tmp1 = this.b2q_1;
            this.b2q_1 = tmp1 + 1 | 0;
            tmp_3.e2q_1 = checkIndexOverflow(tmp1);
            var tmp_4 = this;
            tmp_4.f2q_1 = this.d2q_1;
            this.g2q_1 = this.x2p_1.u2m(this.e2q_1);
            this.v8_1 = 2;
            suspendResult = concealElement(this.u2p_1, this.f2q_1, this.w2p_1, this.g2q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.h2q_1 = suspendResult;
            if (this.u2p_1.y2q_1(this.g2q_1, this.f2q_1)) {
              this.j2q_1 = Companion_instance_2.q2k(this.h2q_1);
              this.w2p_1.e(this.j2q_1);
              this.v8_1 = 3;
              suspendResult = this.j2q_1.g2l(this.u2p_1.x2q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_5 = this;
              tmp_5.i2q_1 = this.h2q_1;
              this.v8_1 = 4;
              continue $sm;
            }

          case 3:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = JsonPrimitive(ARGUMENT);
            var ARGUMENT_1 = to('...', ARGUMENT_0);
            var ARGUMENT_2 = mapOf(ARGUMENT_1);
            this.i2q_1 = new JsonObject(ARGUMENT_2);
            this.v8_1 = 4;
            continue $sm;
          case 4:
            var ARGUMENT_3 = this.i2q_1;
            this.a2q_1.e(ARGUMENT_3);
            this.v8_1 = 1;
            continue $sm;
          case 5:
            var ARGUMENT_4 = this.a2q_1;
            return new JsonArray(ARGUMENT_4);
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function SdJwtConcealer(hashAlgorithmName, hashFunction, concealPredicate) {
    this.w2q_1 = hashAlgorithmName;
    this.x2q_1 = hashFunction;
    this.y2q_1 = concealPredicate;
  }
  protoOf(SdJwtConcealer).z2q = function (obj, $completion) {
    var tmp = new $concealCOROUTINE$3(this, obj, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function $buildCOROUTINE$8(_this__u8e3s4, iat, aud, nonce, issuerJwt, issuerJwtString, disclosureStrings, signingKey, signingAlg, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i2r_1 = _this__u8e3s4;
    this.j2r_1 = iat;
    this.k2r_1 = aud;
    this.l2r_1 = nonce;
    this.m2r_1 = issuerJwt;
    this.n2r_1 = issuerJwtString;
    this.o2r_1 = disclosureStrings;
    this.p2r_1 = signingKey;
    this.q2r_1 = signingAlg;
  }
  protoOf($buildCOROUTINE$8).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.v8_1 = 1;
            suspendResult = Companion_instance_6.o2n(this.m2r_1, this.n2r_1, this.o2r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r2r_1 = suspendResult;
            this.s2r_1 = new JsonJwsHeader(this.q2r_1, 'kb+jwt');
            var tmp_0 = this;
            var tmp10_iat = this.j2r_1.f1m();
            var tmp11_aud = DefaultJsonMultiValue_init_$Create$(this.k2r_1);
            var tmp12_customClaims = mapOf_0([to('nonce', JsonPrimitive(this.l2r_1)), to('sd_hash', JsonPrimitive(this.r2r_1))]);
            tmp_0.t2r_1 = new JsonJwtClaimsSet(VOID, VOID, tmp11_aud, VOID, VOID, tmp10_iat, VOID, VOID, tmp12_customClaims);
            this.v8_1 = 2;
            suspendResult = JwsUtil_getInstance().j2d(this.p2r_1, this.s2r_1, this.t2r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function SdJwtKeyBindingBuilder() {
  }
  protoOf(SdJwtKeyBindingBuilder).u2r = function (iat, aud, nonce, issuerJwt, issuerJwtString, disclosureStrings, signingKey, signingAlg, $completion) {
    var tmp = new $buildCOROUTINE$8(this, iat, aud, nonce, issuerJwt, issuerJwtString, disclosureStrings, signingKey, signingAlg, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var SdJwtKeyBindingBuilder_instance;
  function SdJwtKeyBindingBuilder_getInstance() {
    return SdJwtKeyBindingBuilder_instance;
  }
  function SdJwtParser$Companion$decodeFromString$slambda($jwtDecoder, resultContinuation) {
    this.d2s_1 = $jwtDecoder;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SdJwtParser$Companion$decodeFromString$slambda).g2s = function (encodedKbJwt, _unused_var__etf5q3, $completion) {
    var tmp = this.h2s(encodedKbJwt, _unused_var__etf5q3, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(SdJwtParser$Companion$decodeFromString$slambda).hj = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    return this.g2s(tmp, p2 instanceof Jws ? p2 : THROW_CCE(), $completion);
  };
  protoOf(SdJwtParser$Companion$decodeFromString$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.d2s_1(this.e2s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(SdJwtParser$Companion$decodeFromString$slambda).h2s = function (encodedKbJwt, _unused_var__etf5q3, completion) {
    var i = new SdJwtParser$Companion$decodeFromString$slambda(this.d2s_1, completion);
    i.e2s_1 = encodedKbJwt;
    i.f2s_1 = _unused_var__etf5q3;
    return i;
  };
  function SdJwtParser$Companion$decodeFromString$slambda_0($jwtDecoder, resultContinuation) {
    var i = new SdJwtParser$Companion$decodeFromString$slambda($jwtDecoder, resultContinuation);
    var l = function (encodedKbJwt, _unused_var__etf5q3, $completion) {
      return i.g2s(encodedKbJwt, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $decodeFromStringCOROUTINE$13(_this__u8e3s4, encodedSdJwt, json, jwtDecoder, kbJwtDecoder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q2s_1 = _this__u8e3s4;
    this.r2s_1 = encodedSdJwt;
    this.s2s_1 = json;
    this.t2s_1 = jwtDecoder;
    this.u2s_1 = kbJwtDecoder;
  }
  protoOf($decodeFromStringCOROUTINE$13).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 9;
            this.v2s_1 = Companion_instance_6.n2n(this.r2s_1).xm();
            this.w2s_1 = this.v2s_1.ba();
            this.x2s_1 = this.v2s_1.ca();
            this.y2s_1 = this.v2s_1.qj();
            this.v8_1 = 1;
            suspendResult = this.t2s_1(this.w2s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z2s_1 = suspendResult;
            if (!(this.y2s_1 == null)) {
              this.v8_1 = 2;
              suspendResult = this.u2s_1(this.y2s_1, this.z2s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.a2t_1 = null;
              this.v8_1 = 3;
              continue $sm;
            }

          case 2:
            this.a2t_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.b2t_1 = this.a2t_1;
            this.c2t_1 = Companion_instance_6.k2n(this.z2s_1);
            if (!(this.b2t_1 == null)) {
              var tmp23_safe_receiver = this.b2t_1.j29_1;
              if (!((tmp23_safe_receiver == null ? null : tmp23_safe_receiver.o29_1) === 'kb+jwt')) {
                throw ValidationException_init_$Create$("KB-JWT must have a 'typ' header with value'kb+jwt'");
              }
              var tmp24_safe_receiver = this.b2t_1.j29_1;
              if ((tmp24_safe_receiver == null ? null : tmp24_safe_receiver.n29_1) == null) {
                throw ValidationException_init_$Create$("KB-JWT must have a 'alg' header");
              }
              var tmp25_safe_receiver = this.b2t_1.j29_1;
              var tmp26_safe_receiver = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.n29_1;
              if ((tmp26_safe_receiver == null ? null : contentEquals(tmp26_safe_receiver, 'none', true)) === true) {
                throw ValidationException_init_$Create$("KB-JWT must not use the 'none' algorithm");
              }
              var tmp_1 = this;
              var sdHash = this.b2t_1.k29_1.vl('sd_hash');
              var tmp_2;
              if (sdHash instanceof JsonPrimitive_0) {
                tmp_2 = sdHash.e1b();
              } else {
                throw ValidationException_init_$Create$("KB-JWT must have a 'sd_hash' string claim");
              }
              tmp_1.d2t_1 = tmp_2;
              this.v8_1 = 4;
              suspendResult = Companion_instance_6.o2n(this.z2s_1, this.w2s_1, this.x2s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 6;
              continue $sm;
            }

          case 4:
            this.e2t_1 = suspendResult;
            this.f2t_1 = this.d2t_1 === this.e2t_1;
            if (!this.f2t_1) {
              throw ValidationException_init_$Create$("KB-JWT has invalid 'sd_hash' value");
            } else {
              this.v8_1 = 5;
              continue $sm;
            }

          case 5:
            this.v8_1 = 6;
            continue $sm;
          case 6:
            this.v8_1 = 7;
            suspendResult = Companion_instance_4.e2m(this.x2s_1, this.c2t_1, this.s2s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.g2t_1 = suspendResult;
            this.h2t_1 = new SdJwtParser(this.g2t_1);
            this.v8_1 = 8;
            suspendResult = disclose_1(this.h2t_1, new JsonObject(this.z2s_1.k29_1.h2a_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            var ARGUMENT = suspendResult;
            return new SdJwt(this.w2s_1, this.z2s_1, ARGUMENT, this.x2s_1, this.y2s_1, this.b2t_1);
          case 9:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 9) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function disclose($this, input, $completion) {
    var tmp = new $discloseCOROUTINE$10($this, input, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function disclose_0($this, input, $completion) {
    var tmp = new $discloseCOROUTINE$11($this, input, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function disclose_1($this, input, $completion) {
    var tmp = new $discloseCOROUTINE$12($this, input, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function Companion_6() {
  }
  protoOf(Companion_6).z2v = function (encodedSdJwt, json, jwtDecoder, $completion) {
    return this.a2w(encodedSdJwt, json, jwtDecoder, SdJwtParser$Companion$decodeFromString$slambda_0(jwtDecoder, null), $completion);
  };
  protoOf(Companion_6).b2w = function (encodedSdJwt, json, jwtDecoder, $completion, $super) {
    json = json === VOID ? Default_getInstance() : json;
    return $super === VOID ? this.z2v(encodedSdJwt, json, jwtDecoder, $completion) : $super.z2v.call(this, encodedSdJwt, json, jwtDecoder, $completion);
  };
  protoOf(Companion_6).a2w = function (encodedSdJwt, json, jwtDecoder, kbJwtDecoder, $completion) {
    var tmp = new $decodeFromStringCOROUTINE$13(this, encodedSdJwt, json, jwtDecoder, kbJwtDecoder, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_8;
  function Companion_getInstance_7() {
    return Companion_instance_8;
  }
  function $discloseCOROUTINE$10(_this__u8e3s4, input, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q2t_1 = _this__u8e3s4;
    this.r2t_1 = input;
  }
  protoOf($discloseCOROUTINE$10).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.s2t_1 = this.r2t_1;
            var tmp_0 = this.s2t_1;
            if (tmp_0 instanceof JsonArray) {
              this.v8_1 = 2;
              suspendResult = disclose_0(this.q2t_1, this.r2t_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.s2t_1;
              if (tmp_1 instanceof JsonObject) {
                this.v8_1 = 1;
                suspendResult = disclose_1(this.q2t_1, this.r2t_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_2 = this.s2t_1;
                if (tmp_2 instanceof JsonPrimitive_0) {
                  this.t2t_1 = new Primitive(this.r2t_1);
                  this.v8_1 = 3;
                  continue $sm;
                } else {
                  if (equals(this.s2t_1, JsonNull_getInstance())) {
                    this.t2t_1 = new Primitive(null);
                    this.v8_1 = 3;
                    continue $sm;
                  } else {
                    var tmp_3 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            this.t2t_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.t2t_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            return this.t2t_1;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $discloseCOROUTINE$11(_this__u8e3s4, input, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c2u_1 = _this__u8e3s4;
    this.d2u_1 = input;
  }
  protoOf($discloseCOROUTINE$11).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 9;
            var tmp_0 = this;
            tmp_0.e2u_1 = ArrayList_init_$Create$_0();
            var tmp_1 = this;
            tmp_1.f2u_1 = this.d2u_1;
            this.g2u_1 = this.f2u_1.j();
            this.v8_1 = 1;
            continue $sm;
          case 1:
            if (!this.g2u_1.k()) {
              this.v8_1 = 8;
              continue $sm;
            }

            this.h2u_1 = this.g2u_1.l();
            var tmp_2 = this;
            tmp_2.i2u_1 = this.h2u_1;
            this.j2u_1 = this.i2u_1;
            var tmp_3 = this.j2u_1;
            if (tmp_3 instanceof JsonPrimitive_0) {
              this.k2u_1 = new SdArrayValue(new Primitive(this.i2u_1));
              this.v8_1 = 7;
              continue $sm;
            } else {
              if (equals(this.j2u_1, JsonNull_getInstance())) {
                this.k2u_1 = new SdArrayValue(new Primitive(null));
                this.v8_1 = 7;
                continue $sm;
              } else {
                var tmp_4 = this.j2u_1;
                if (tmp_4 instanceof JsonArray) {
                  this.v8_1 = 6;
                  suspendResult = disclose_0(this.c2u_1, this.i2u_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_5 = this.j2u_1;
                  if (tmp_5 instanceof JsonObject) {
                    this.l2u_1 = singleOrNull(this.i2u_1.z());
                    var tmp_6 = this;
                    var tmp19_safe_receiver = this.l2u_1;
                    tmp_6.m2u_1 = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.b1();
                    var tmp_7;
                    var tmp_8;
                    var tmp21_safe_receiver = this.l2u_1;
                    if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.a1()) === '...') {
                      var tmp_9 = this.m2u_1;
                      tmp_8 = tmp_9 instanceof JsonPrimitive_0;
                    } else {
                      tmp_8 = false;
                    }
                    if (tmp_8) {
                      tmp_7 = this.m2u_1.d1b();
                    } else {
                      tmp_7 = false;
                    }
                    if (tmp_7) {
                      this.o2u_1 = this.c2u_1.c2w_1.i2m(this.m2u_1.e1b());
                      if (this.o2u_1 == null) {
                        this.p2u_1 = null;
                        this.v8_1 = 4;
                        continue $sm;
                      } else {
                        var tmp_10 = this;
                        tmp_10.q2u_1 = this.o2u_1;
                        var tmp_11 = this;
                        tmp_11.r2u_1 = this.q2u_1;
                        this.s2u_1 = this.r2u_1.ba();
                        this.t2u_1 = this.r2u_1.ca();
                        this.v8_1 = 3;
                        suspendResult = disclose(this.c2u_1, this.s2u_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      }
                    } else {
                      this.v8_1 = 2;
                      suspendResult = disclose_1(this.c2u_1, this.i2u_1, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    }
                  } else {
                    var tmp_12 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 2:
            var ARGUMENT = suspendResult;
            this.n2u_1 = new SdArrayValue(ARGUMENT);
            this.v8_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.p2u_1 = new SdArrayValue(ARGUMENT_0, this.t2u_1);
            this.v8_1 = 4;
            continue $sm;
          case 4:
            this.n2u_1 = this.p2u_1;
            this.v8_1 = 5;
            continue $sm;
          case 5:
            this.k2u_1 = this.n2u_1;
            this.v8_1 = 7;
            continue $sm;
          case 6:
            var ARGUMENT_1 = suspendResult;
            this.k2u_1 = new SdArrayValue(ARGUMENT_1);
            this.v8_1 = 7;
            continue $sm;
          case 7:
            var sdValue = this.k2u_1;
            if (!(sdValue == null)) {
              this.e2u_1.e(sdValue);
            }

            this.v8_1 = 1;
            continue $sm;
          case 8:
            var this_0 = this.e2u_1;
            return new Array_0(copyToArray(this_0));
          case 9:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 9) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $discloseCOROUTINE$12(_this__u8e3s4, input, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c2v_1 = _this__u8e3s4;
    this.d2v_1 = input;
  }
  protoOf($discloseCOROUTINE$12).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 10;
            var tmp_0 = this;
            tmp_0.e2v_1 = LinkedHashMap_init_$Create$_0();
            this.f2v_1 = this.d2v_1.vl('_sd');
            if (!(this.f2v_1 == null)) {
              var tmp_1 = this.f2v_1;
              if (!(tmp_1 instanceof JsonArray)) {
                throw IllegalArgumentException_init_$Create$_0("Invalid '$_sd_alg' claim: must be an array");
              }
              var tmp_2 = this;
              tmp_2.g2v_1 = this.f2v_1;
              this.h2v_1 = this.g2v_1.j();
              this.v8_1 = 1;
              continue $sm;
            } else {
              this.v8_1 = 5;
              continue $sm;
            }

          case 1:
            if (!this.h2v_1.k()) {
              this.v8_1 = 4;
              continue $sm;
            }

            this.i2v_1 = this.h2v_1.l();
            var tmp_3 = this;
            tmp_3.j2v_1 = this.i2v_1;
            var tmp_4;
            var tmp_5 = this.j2v_1;
            if (!(tmp_5 instanceof JsonPrimitive_0)) {
              tmp_4 = true;
            } else {
              tmp_4 = !this.j2v_1.d1b();
            }

            if (tmp_4) {
              throw IllegalArgumentException_init_$Create$_0("Invalid '_sd_alg' claim: all its elements must be strings");
            }

            this.k2v_1 = this.j2v_1.e1b();
            this.l2v_1 = this.c2v_1.c2w_1.h2m(this.k2v_1);
            if (this.l2v_1 == null) {
              this.m2v_1 = null;
              this.v8_1 = 3;
              continue $sm;
            } else {
              var tmp_6 = this;
              tmp_6.n2v_1 = this.l2v_1;
              var tmp_7 = this;
              tmp_7.o2v_1 = this.n2v_1;
              this.p2v_1 = this.o2v_1.ba();
              this.q2v_1 = this.o2v_1.ca();
              this.r2v_1 = this.o2v_1.qj();
              this.v8_1 = 2;
              suspendResult = disclose(this.c2v_1, this.q2v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.s2v_1 = suspendResult;
            var tmp_8 = this;
            var this_0 = this.e2v_1;
            var key = this.p2v_1;
            var value = new SdProperty(this.p2v_1, this.s2v_1, this.r2v_1);
            this_0.m2(key, value);
            tmp_8.m2v_1 = Unit_instance;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.v8_1 = 1;
            continue $sm;
          case 4:
            this.v8_1 = 5;
            continue $sm;
          case 5:
            var tmp_9 = this;
            tmp_9.t2v_1 = this.d2v_1.z();
            this.u2v_1 = this.t2v_1.j();
            this.v8_1 = 6;
            continue $sm;
          case 6:
            if (!this.u2v_1.k()) {
              this.v8_1 = 9;
              continue $sm;
            }

            this.v2v_1 = this.u2v_1.l();
            var tmp_10 = this;
            tmp_10.w2v_1 = this.v2v_1;
            var tmp_11 = this;
            tmp_11.x2v_1 = this.w2v_1.a1();
            var tmp_12 = this;
            tmp_12.y2v_1 = this.w2v_1.b1();
            if (!(this.x2v_1 === '_sd') && !(this.x2v_1 === '_sd_alg')) {
              this.v8_1 = 7;
              suspendResult = disclose(this.c2v_1, this.y2v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 8;
              continue $sm;
            }

          case 7:
            var sdValue = suspendResult;
            var this_1 = this.e2v_1;
            var key_0 = this.x2v_1;
            var value_0 = new SdProperty(this.x2v_1, sdValue);
            this_1.m2(key_0, value_0);
            this.v8_1 = 8;
            continue $sm;
          case 8:
            this.v8_1 = 6;
            continue $sm;
          case 9:
            return new Object_0(this.e2v_1);
          case 10:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 10) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function SdJwtParser(disclosuresByHash) {
    this.c2w_1 = disclosuresByHash;
  }
  function Companion_7() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2w_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_3())];
  }
  var Companion_instance_9;
  function Companion_getInstance_8() {
    if (Companion_instance_9 == null)
      new Companion_7();
    return Companion_instance_9;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.sdjwt.SdValue.Object', this, 1);
    tmp0_serialDesc.wy('members', false);
    this.e2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer).f2w = function (encoder, value) {
    var tmp0_desc = this.e2w_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_8().d2w_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.g2w_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer).zn = function (encoder, value) {
    return this.f2w(encoder, value instanceof Object_0 ? value : THROW_CCE());
  };
  protoOf($serializer).ao = function (decoder) {
    var tmp0_desc = this.e2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_8().d2w_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return Object_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).yn = function () {
    return this.e2w_1;
  };
  protoOf($serializer).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_8().d2w_1[0]];
  };
  var $serializer_instance;
  function $serializer_getInstance_0() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function Object_init_$Init$(seen0, members, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_0().e2w_1);
    }
    $this.g2w_1 = members;
    return $this;
  }
  function Object_init_$Create$(seen0, members, serializationConstructorMarker) {
    return Object_init_$Init$(seen0, members, serializationConstructorMarker, objectCreate(protoOf(Object_0)));
  }
  function Companion_8() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2w_1 = [new ReferenceArraySerializer(getKClass(SdArrayValue), $serializer_getInstance_4())];
  }
  var Companion_instance_10;
  function Companion_getInstance_9() {
    if (Companion_instance_10 == null)
      new Companion_8();
    return Companion_instance_10;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.sdjwt.SdValue.Array', this, 1);
    tmp0_serialDesc.wy('elements', false);
    this.i2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).j2w = function (encoder, value) {
    var tmp0_desc = this.i2w_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().h2w_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.k2w_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_0).zn = function (encoder, value) {
    return this.j2w(encoder, value instanceof Array_0 ? value : THROW_CCE());
  };
  protoOf($serializer_0).ao = function (decoder) {
    var tmp0_desc = this.i2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_9().h2w_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return Array_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_0).yn = function () {
    return this.i2w_1;
  };
  protoOf($serializer_0).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_9().h2w_1[0]];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_1() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function Array_init_$Init$(seen0, elements, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().i2w_1);
    }
    $this.k2w_1 = elements;
    return $this;
  }
  function Array_init_$Create$(seen0, elements, serializationConstructorMarker) {
    return Array_init_$Init$(seen0, elements, serializationConstructorMarker, objectCreate(protoOf(Array_0)));
  }
  function Companion_9() {
  }
  var Companion_instance_11;
  function Companion_getInstance_10() {
    return Companion_instance_11;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.sdjwt.SdValue.Primitive', this, 1);
    tmp0_serialDesc.wy('value', false);
    this.l2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).m2w = function (encoder, value) {
    var tmp0_desc = this.l2w_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.dt(tmp0_desc, 0, JsonPrimitiveSerializer_getInstance(), value.n2w_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_1).zn = function (encoder, value) {
    return this.m2w(encoder, value instanceof Primitive ? value : THROW_CCE());
  };
  protoOf($serializer_1).ao = function (decoder) {
    var tmp0_desc = this.l2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, JsonPrimitiveSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, JsonPrimitiveSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return Primitive_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).yn = function () {
    return this.l2w_1;
  };
  protoOf($serializer_1).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(JsonPrimitiveSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_2() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function Primitive_init_$Init$(seen0, value, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_2().l2w_1);
    }
    $this.n2w_1 = value;
    return $this;
  }
  function Primitive_init_$Create$(seen0, value, serializationConstructorMarker) {
    return Primitive_init_$Init$(seen0, value, serializationConstructorMarker, objectCreate(protoOf(Primitive)));
  }
  function Object_0(members) {
    Companion_getInstance_8();
    this.g2w_1 = members;
  }
  protoOf(Object_0).toString = function () {
    return 'Object(members=' + toString_0(this.g2w_1) + ')';
  };
  protoOf(Object_0).hashCode = function () {
    return hashCode(this.g2w_1);
  };
  protoOf(Object_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Object_0))
      return false;
    var tmp0_other_with_cast = other instanceof Object_0 ? other : THROW_CCE();
    if (!equals(this.g2w_1, tmp0_other_with_cast.g2w_1))
      return false;
    return true;
  };
  function Array_0(elements) {
    Companion_getInstance_9();
    this.k2w_1 = elements;
  }
  protoOf(Array_0).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Array_0))
      THROW_CCE();
    return contentEquals_0(this.k2w_1, other.k2w_1);
  };
  protoOf(Array_0).hashCode = function () {
    return contentHashCode(this.k2w_1);
  };
  protoOf(Array_0).toString = function () {
    return 'Array(elements=' + toString_0(this.k2w_1) + ')';
  };
  function Primitive(value) {
    this.n2w_1 = value;
  }
  protoOf(Primitive).toString = function () {
    return 'Primitive(value=' + toString(this.n2w_1) + ')';
  };
  protoOf(Primitive).hashCode = function () {
    return this.n2w_1 == null ? 0 : hashCode(this.n2w_1);
  };
  protoOf(Primitive).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Primitive))
      return false;
    var tmp0_other_with_cast = other instanceof Primitive ? other : THROW_CCE();
    if (!equals(this.n2w_1, tmp0_other_with_cast.n2w_1))
      return false;
    return true;
  };
  function Companion_10() {
  }
  protoOf(Companion_10).b1b = function () {
    var tmp = getKClass(SdValue);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Array_0), getKClass(Object_0), getKClass(Primitive)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_1(), $serializer_getInstance_0(), $serializer_getInstance_2()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('io.curity.ssi.sdjwt.SdValue', tmp, tmp_0, tmp_1, tmp$ret$8);
  };
  protoOf(Companion_10).wz = function (typeParamsSerializers) {
    return this.b1b();
  };
  var Companion_instance_12;
  function Companion_getInstance_11() {
    return Companion_instance_12;
  }
  function SdValue() {
  }
  function Companion_11() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(SdValue);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [getKClass(Array_0), getKClass(Object_0), getKClass(Primitive)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = [$serializer_getInstance_1(), $serializer_getInstance_0(), $serializer_getInstance_2()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2w_1 = [null, SealedClassSerializer_init_$Create$('io.curity.ssi.sdjwt.SdValue', tmp_0, tmp_1, tmp_2, tmp$ret$8), null];
  }
  var Companion_instance_13;
  function Companion_getInstance_12() {
    if (Companion_instance_13 == null)
      new Companion_11();
    return Companion_instance_13;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.sdjwt.SdProperty', this, 3);
    tmp0_serialDesc.wy('name', false);
    tmp0_serialDesc.wy('value', false);
    tmp0_serialDesc.wy('disclosureString', true);
    this.p2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).q2w = function (encoder, value) {
    var tmp0_desc = this.p2w_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_12().o2w_1;
    tmp1_output.zs(tmp0_desc, 0, value.r2w_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.s2w_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.t2w_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.t2w_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_2).zn = function (encoder, value) {
    return this.q2w(encoder, value instanceof SdProperty ? value : THROW_CCE());
  };
  protoOf($serializer_2).ao = function (decoder) {
    var tmp0_desc = this.p2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    var tmp8_cached = Companion_getInstance_12().o2w_1;
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return SdProperty_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_2).yn = function () {
    return this.p2w_1;
  };
  protoOf($serializer_2).lz = function () {
    var tmp0_cached = Companion_getInstance_12().o2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_3() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function SdProperty_init_$Init$(seen0, name, value, disclosureString, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_3().p2w_1);
    }
    $this.r2w_1 = name;
    $this.s2w_1 = value;
    if (0 === (seen0 & 4))
      $this.t2w_1 = null;
    else
      $this.t2w_1 = disclosureString;
    return $this;
  }
  function SdProperty_init_$Create$(seen0, name, value, disclosureString, serializationConstructorMarker) {
    return SdProperty_init_$Init$(seen0, name, value, disclosureString, serializationConstructorMarker, objectCreate(protoOf(SdProperty)));
  }
  function SdProperty(name, value, disclosureString) {
    Companion_getInstance_12();
    disclosureString = disclosureString === VOID ? null : disclosureString;
    this.r2w_1 = name;
    this.s2w_1 = value;
    this.t2w_1 = disclosureString;
  }
  protoOf(SdProperty).toString = function () {
    return 'SdProperty(name=' + this.r2w_1 + ', value=' + toString_0(this.s2w_1) + ', disclosureString=' + this.t2w_1 + ')';
  };
  protoOf(SdProperty).hashCode = function () {
    var result = getStringHashCode(this.r2w_1);
    result = imul(result, 31) + hashCode(this.s2w_1) | 0;
    result = imul(result, 31) + (this.t2w_1 == null ? 0 : getStringHashCode(this.t2w_1)) | 0;
    return result;
  };
  protoOf(SdProperty).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SdProperty))
      return false;
    var tmp0_other_with_cast = other instanceof SdProperty ? other : THROW_CCE();
    if (!(this.r2w_1 === tmp0_other_with_cast.r2w_1))
      return false;
    if (!equals(this.s2w_1, tmp0_other_with_cast.s2w_1))
      return false;
    if (!(this.t2w_1 == tmp0_other_with_cast.t2w_1))
      return false;
    return true;
  };
  function Companion_12() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(SdValue);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [getKClass(Array_0), getKClass(Object_0), getKClass(Primitive)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = [$serializer_getInstance_1(), $serializer_getInstance_0(), $serializer_getInstance_2()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u2w_1 = [SealedClassSerializer_init_$Create$('io.curity.ssi.sdjwt.SdValue', tmp_0, tmp_1, tmp_2, tmp$ret$8), null];
  }
  var Companion_instance_14;
  function Companion_getInstance_13() {
    if (Companion_instance_14 == null)
      new Companion_12();
    return Companion_instance_14;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.sdjwt.SdArrayValue', this, 2);
    tmp0_serialDesc.wy('value', false);
    tmp0_serialDesc.wy('disclosureString', true);
    this.v2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).w2w = function (encoder, value) {
    var tmp0_desc = this.v2w_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().u2w_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.x2w_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.y2w_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.y2w_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_3).zn = function (encoder, value) {
    return this.w2w(encoder, value instanceof SdArrayValue ? value : THROW_CCE());
  };
  protoOf($serializer_3).ao = function (decoder) {
    var tmp0_desc = this.v2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    var tmp7_cached = Companion_getInstance_13().u2w_1;
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return SdArrayValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).yn = function () {
    return this.v2w_1;
  };
  protoOf($serializer_3).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_13().u2w_1[0], get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_4() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function SdArrayValue_init_$Init$(seen0, value, disclosureString, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_4().v2w_1);
    }
    $this.x2w_1 = value;
    if (0 === (seen0 & 2))
      $this.y2w_1 = null;
    else
      $this.y2w_1 = disclosureString;
    return $this;
  }
  function SdArrayValue_init_$Create$(seen0, value, disclosureString, serializationConstructorMarker) {
    return SdArrayValue_init_$Init$(seen0, value, disclosureString, serializationConstructorMarker, objectCreate(protoOf(SdArrayValue)));
  }
  function SdArrayValue(value, disclosureString) {
    Companion_getInstance_13();
    disclosureString = disclosureString === VOID ? null : disclosureString;
    this.x2w_1 = value;
    this.y2w_1 = disclosureString;
  }
  protoOf(SdArrayValue).toString = function () {
    return 'SdArrayValue(value=' + toString_0(this.x2w_1) + ', disclosureString=' + this.y2w_1 + ')';
  };
  protoOf(SdArrayValue).hashCode = function () {
    var result = hashCode(this.x2w_1);
    result = imul(result, 31) + (this.y2w_1 == null ? 0 : getStringHashCode(this.y2w_1)) | 0;
    return result;
  };
  protoOf(SdArrayValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SdArrayValue))
      return false;
    var tmp0_other_with_cast = other instanceof SdArrayValue ? other : THROW_CCE();
    if (!equals(this.x2w_1, tmp0_other_with_cast.x2w_1))
      return false;
    if (!(this.y2w_1 == tmp0_other_with_cast.y2w_1))
      return false;
    return true;
  };
  function Result_0(iss, vct, cnf) {
    this.z2w_1 = iss;
    this.a2x_1 = vct;
    this.b2x_1 = cnf;
  }
  protoOf(Result_0).toString = function () {
    return 'Result(iss=' + this.z2w_1 + ', vct=' + this.a2x_1 + ', cnf=' + this.b2x_1.toString() + ')';
  };
  protoOf(Result_0).hashCode = function () {
    var result = getStringHashCode(this.z2w_1);
    result = imul(result, 31) + getStringHashCode(this.a2x_1) | 0;
    result = imul(result, 31) + this.b2x_1.hashCode() | 0;
    return result;
  };
  protoOf(Result_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result_0))
      return false;
    var tmp0_other_with_cast = other instanceof Result_0 ? other : THROW_CCE();
    if (!(this.z2w_1 === tmp0_other_with_cast.z2w_1))
      return false;
    if (!(this.a2x_1 === tmp0_other_with_cast.a2x_1))
      return false;
    if (!this.b2x_1.equals(tmp0_other_with_cast.b2x_1))
      return false;
    return true;
  };
  function validateIssuerJwtHeaderAndGetKid(_this__u8e3s4, $this, header) {
    _this__u8e3s4.tn("'typ' claim is not present in the header", header.o29_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtHeaderAndGetKid$lambda(_this__u8e3s4));
    return header.s29_1;
  }
  function validateIssuerJwtPayload(_this__u8e3s4, $this, payload) {
    var nowEpoch = $this.c2x_1.u1l().f1m();
    var tmp = payload.h2a_1.e2('vct');
    var vct = _this__u8e3s4.un('vct', tmp, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda);
    var iss = _this__u8e3s4.un('iss', payload.z29_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_0);
    _this__u8e3s4.wn(payload.d2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_1(nowEpoch, _this__u8e3s4));
    _this__u8e3s4.wn(payload.e2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_2(nowEpoch, _this__u8e3s4));
    _this__u8e3s4.wn(payload.c2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_3(nowEpoch, _this__u8e3s4));
    var cnfJwk = _this__u8e3s4.un('cnf', payload.g2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_4);
    var tmp_0;
    if (!(iss == null) && !(vct == null) && !(cnfJwk == null)) {
      tmp_0 = new ValidatedPayload(iss, vct, cnfJwk);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function validateJwtSignature(_this__u8e3s4, $this, issuerId, jwtString, kid, $completion) {
    var tmp = new $validateJwtSignatureCOROUTINE$16($this, _this__u8e3s4, issuerId, jwtString, kid, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function ValidatedPayload(iss, vct, cnf) {
    this.z2x_1 = iss;
    this.a2y_1 = vct;
    this.b2y_1 = cnf;
  }
  protoOf(ValidatedPayload).toString = function () {
    return 'ValidatedPayload(iss=' + this.z2x_1 + ', vct=' + this.a2y_1 + ', cnf=' + this.b2y_1.toString() + ')';
  };
  protoOf(ValidatedPayload).hashCode = function () {
    var result = getStringHashCode(this.z2x_1);
    result = imul(result, 31) + getStringHashCode(this.a2y_1) | 0;
    result = imul(result, 31) + this.b2y_1.hashCode() | 0;
    return result;
  };
  protoOf(ValidatedPayload).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ValidatedPayload))
      return false;
    var tmp0_other_with_cast = other instanceof ValidatedPayload ? other : THROW_CCE();
    if (!(this.z2x_1 === tmp0_other_with_cast.z2x_1))
      return false;
    if (!(this.a2y_1 === tmp0_other_with_cast.a2y_1))
      return false;
    if (!this.b2y_1.equals(tmp0_other_with_cast.b2y_1))
      return false;
    return true;
  };
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtHeaderAndGetKid$lambda($this_validateIssuerJwtHeaderAndGetKid) {
    return function (it) {
      var tmp;
      if (!(it === 'vc+sd-jwt')) {
        $this_validateIssuerJwtHeaderAndGetKid.vn("JWS header 'kid' is not 'vc+sd-jwt'");
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda($this$mandatory, it) {
    var tmp;
    if (it instanceof JsonPrimitive_0) {
      var tmp_0;
      if (it.d1b()) {
        tmp_0 = it.e1b();
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    } else {
      tmp = null;
    }
    var stringValue = tmp;
    if (stringValue == null) {
      $this$mandatory.vn("'vct' is present but is not a string");
    }
    return stringValue;
  }
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_0($this$mandatory, it) {
    return it;
  }
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_1($nowEpoch, $this_validateIssuerJwtPayload) {
    return function (it) {
      var tmp;
      if ($nowEpoch.j1(it) < 0) {
        $this_validateIssuerJwtPayload.vn("'nbf' is in the future");
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_2($nowEpoch, $this_validateIssuerJwtPayload) {
    return function (it) {
      var tmp;
      if ($nowEpoch.j1(it) < 0) {
        $this_validateIssuerJwtPayload.vn("'iat' is in the future");
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_3($nowEpoch, $this_validateIssuerJwtPayload) {
    return function (it) {
      var tmp;
      if ($nowEpoch.j1(it) > 0) {
        $this_validateIssuerJwtPayload.vn("'exp' is in the past");
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_4($this$mandatory, it) {
    if (!equals(it.f2(), setOf('jwk'))) {
      $this$mandatory.vn("'cnf' has unexpected members");
    }
    var jwk = it.vl('jwk');
    if (jwk == null) {
      $this$mandatory.vn("'cnf.jwk' is missing in the 'cnf' claim");
      return null;
    }
    var jwkObject = jwk instanceof JsonObject ? jwk : null;
    if (jwkObject == null) {
      $this$mandatory.vn("'cnf.jwk' is not a JSON object");
      return null;
    }
    return Companion_getInstance().d27(jwkObject);
  }
  function $validateIssuerJwtCOROUTINE$15(_this__u8e3s4, validationScope, jwt, jwtString, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k2y_1 = _this__u8e3s4;
    this.l2y_1 = validationScope;
    this.m2y_1 = jwt;
    this.n2y_1 = jwtString;
  }
  protoOf($validateIssuerJwtCOROUTINE$15).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            var tmp_0 = this;
            tmp_0.o2y_1 = this.l2y_1;
            var tmp_1 = this;
            tmp_1.p2y_1 = this.o2y_1;
            var tmp_2 = this;
            var header = this.m2y_1.j29_1;
            var tmp_3;
            if (header == null) {
              this.p2y_1.vn('JWS Header is missing');
              tmp_3 = null;
            } else {
              validateIssuerJwtHeaderAndGetKid(this.p2y_1, this.k2y_1, header);
              tmp_3 = header.s29_1;
            }

            tmp_2.q2y_1 = tmp_3;
            this.r2y_1 = validateIssuerJwtPayload(this.p2y_1, this.k2y_1, this.m2y_1.k29_1);
            if (this.p2y_1.rn_1 || this.q2y_1 == null || this.r2y_1 == null) {
              return null;
            }

            this.v8_1 = 1;
            suspendResult = validateJwtSignature(this.p2y_1, this.k2y_1, this.r2y_1.z2x_1, this.n2y_1, this.q2y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return new Result_0(this.r2y_1.z2x_1, this.r2y_1.a2y_1, this.r2y_1.b2y_1);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $validateJwtSignatureCOROUTINE$16(_this__u8e3s4, _this__u8e3s4_0, issuerId, jwtString, kid, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m2x_1 = _this__u8e3s4;
    this.n2x_1 = _this__u8e3s4_0;
    this.o2x_1 = issuerId;
    this.p2x_1 = jwtString;
    this.q2x_1 = kid;
  }
  protoOf($validateJwtSignatureCOROUTINE$16).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 9;
            this.w8_1 = 5;
            this.v8_1 = 1;
            suspendResult = this.m2x_1.d2x_1.s2y(this.o2x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.s2x_1 = suspendResult;
            if (!(this.s2x_1.t2y_1 === this.o2x_1)) {
              var tmp_0 = this;
              this.n2x_1.vn('Issuer metadata ID mismatch, metadata has ' + ("'" + this.s2x_1.t2y_1 + "', credential has '" + this.o2x_1 + "'"));
              tmp_0.t2x_1 = null;
              this.v8_1 = 4;
              continue $sm;
            } else {
              this.u2x_1 = this.s2x_1.u2y_1.g29(this.q2x_1);
              if (this.u2x_1 == null) {
                var tmp_1 = this;
                this.n2x_1.vn('Issuer metadata does not contain credential verification key');
                tmp_1.v2x_1 = null;
                this.v8_1 = 3;
                continue $sm;
              } else {
                this.v8_1 = 2;
                suspendResult = fromJwkDictionary(Companion_instance_0, this.u2x_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            this.v2x_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.t2x_1 = this.v2x_1;
            this.v8_1 = 4;
            continue $sm;
          case 4:
            this.r2x_1 = this.t2x_1;
            this.w8_1 = 9;
            this.v8_1 = 6;
            continue $sm;
          case 5:
            this.w8_1 = 9;
            var tmp_2 = this.y8_1;
            if (tmp_2 instanceof Exception) {
              this.w2x_1 = this.y8_1;
              var tmp_3 = this;
              this.n2x_1.vn('Unexpected exception: ' + this.w2x_1.message);
              tmp_3.r2x_1 = null;
              this.v8_1 = 6;
              continue $sm;
            } else {
              throw this.y8_1;
            }

          case 6:
            this.w8_1 = 9;
            this.x2x_1 = this.r2x_1;
            if (this.x2x_1 == null) {
              return false;
            }

            this.w8_1 = 8;
            this.v8_1 = 7;
            suspendResult = JwsUtil_getInstance().w2d(this.x2x_1, this.p2x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.y2x_1 = true;
            this.w8_1 = 9;
            this.v8_1 = 10;
            continue $sm;
          case 8:
            this.w8_1 = 9;
            var tmp_4 = this.y8_1;
            if (tmp_4 instanceof Exception) {
              var ex = this.y8_1;
              var tmp_5 = this;
              this.n2x_1.vn('JWT is not valid: ' + ex.message);
              tmp_5.y2x_1 = false;
              this.v8_1 = 10;
              continue $sm;
            } else {
              throw this.y8_1;
            }

          case 9:
            throw this.y8_1;
          case 10:
            this.w8_1 = 9;
            return this.y2x_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 9) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function VcSdJwtIssuerJwtValidator(clock, issuerMetadataLoader) {
    this.c2x_1 = clock;
    this.d2x_1 = issuerMetadataLoader;
  }
  protoOf(VcSdJwtIssuerJwtValidator).v2y = function (validationScope, jwt, jwtString, $completion) {
    var tmp = new $validateIssuerJwtCOROUTINE$15(this, validationScope, jwt, jwtString, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function Companion_13() {
  }
  var Companion_instance_15;
  function Companion_getInstance_14() {
    return Companion_instance_15;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.sdjwt.vc.JsonVcSdJwtIssuerMetadata', this, 2);
    tmp0_serialDesc.wy('issuer', false);
    tmp0_serialDesc.wy('jwks', false);
    this.w2y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).x2y = function (encoder, value) {
    var tmp0_desc = this.w2y_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.t2y_1);
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance(), value.u2y_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_4).zn = function (encoder, value) {
    return this.x2y(encoder, value instanceof JsonVcSdJwtIssuerMetadata ? value : THROW_CCE());
  };
  protoOf($serializer_4).ao = function (decoder) {
    var tmp0_desc = this.w2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonVcSdJwtIssuerMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_4).yn = function () {
    return this.w2y_1;
  };
  protoOf($serializer_4).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_5() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function JsonVcSdJwtIssuerMetadata_init_$Init$(seen0, issuer, jwks, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_5().w2y_1);
    }
    $this.t2y_1 = issuer;
    $this.u2y_1 = jwks;
    return $this;
  }
  function JsonVcSdJwtIssuerMetadata_init_$Create$(seen0, issuer, jwks, serializationConstructorMarker) {
    return JsonVcSdJwtIssuerMetadata_init_$Init$(seen0, issuer, jwks, serializationConstructorMarker, objectCreate(protoOf(JsonVcSdJwtIssuerMetadata)));
  }
  function JsonVcSdJwtIssuerMetadata(issuer, jwks) {
    this.t2y_1 = issuer;
    this.u2y_1 = jwks;
  }
  protoOf(JsonVcSdJwtIssuerMetadata).toString = function () {
    return 'JsonVcSdJwtIssuerMetadata(issuer=' + this.t2y_1 + ', jwks=' + toString_0(this.u2y_1) + ')';
  };
  protoOf(JsonVcSdJwtIssuerMetadata).hashCode = function () {
    var result = getStringHashCode(this.t2y_1);
    result = imul(result, 31) + hashCode(this.u2y_1) | 0;
    return result;
  };
  protoOf(JsonVcSdJwtIssuerMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonVcSdJwtIssuerMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof JsonVcSdJwtIssuerMetadata ? other : THROW_CCE();
    if (!(this.t2y_1 === tmp0_other_with_cast.t2y_1))
      return false;
    if (!equals(this.u2y_1, tmp0_other_with_cast.u2y_1))
      return false;
    return true;
  };
  function parseSdJwt(sdJwtString) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, parseSdJwt$slambda_0(sdJwtString, null));
  }
  function SdJwtParseResult(jwtString, kbJwtString, disclosures, disclosedClaims) {
    this.jwtString = jwtString;
    this.kbJwtString = kbJwtString;
    this.disclosures = disclosures;
    this.disclosedClaims = disclosedClaims;
  }
  protoOf(SdJwtParseResult).y2y = function () {
    return this.jwtString;
  };
  protoOf(SdJwtParseResult).z2y = function () {
    return this.kbJwtString;
  };
  protoOf(SdJwtParseResult).a2z = function () {
    return this.disclosures;
  };
  protoOf(SdJwtParseResult).b2z = function () {
    return this.disclosedClaims;
  };
  function SdValue_0() {
  }
  function SdObject(propertyMap) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = propertyMap.g2();
    tmp.properties = copyToArray(this_0);
  }
  protoOf(SdObject).c2z = function () {
    return this.properties;
  };
  function SdArray(values) {
    this.values = values;
  }
  protoOf(SdArray).g2 = function () {
    return this.values;
  };
  function SdPrimitive(value) {
    this.value = value;
  }
  protoOf(SdPrimitive).b1 = function () {
    return this.value;
  };
  function SdArrayValue_0(value, disclosure) {
    this.value = value;
    this.disclosure = disclosure;
  }
  protoOf(SdArrayValue_0).b1 = function () {
    return this.value;
  };
  protoOf(SdArrayValue_0).d2z = function () {
    return this.disclosure;
  };
  function SdProperty_0(name, value, disclosure) {
    this.name = name;
    this.value = value;
    this.disclosure = disclosure;
  }
  protoOf(SdProperty_0).r2 = function () {
    return this.name;
  };
  protoOf(SdProperty_0).b1 = function () {
    return this.value;
  };
  protoOf(SdProperty_0).d2z = function () {
    return this.disclosure;
  };
  function concealSdJwt(input, pathsToConceal) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, concealSdJwt$slambda_0(input, pathsToConceal, null));
  }
  function ConcealResult(output, disclosures) {
    this.output = output;
    this.disclosures = disclosures;
  }
  protoOf(ConcealResult).e2z = function () {
    return this.output;
  };
  protoOf(ConcealResult).a2z = function () {
    return this.disclosures;
  };
  function mapObject(input) {
    // Inline function 'kotlin.collections.mapValues' call
    var this_0 = input.g2w_1;
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$(mapCapacity(this_0.m()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.z().j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp = element.a1();
      // Inline function 'mapObject.<anonymous>' call
      var tmp$ret$1 = new SdProperty_0(element.b1().r2w_1, map(element.b1().s2w_1), element.b1().t2w_1);
      destination.m2(tmp, tmp$ret$1);
    }
    return new SdObject(destination);
  }
  function map(input) {
    var tmp;
    if (input instanceof Array_0) {
      tmp = mapArray(input);
    } else {
      if (input instanceof Object_0) {
        tmp = mapObject(input);
      } else {
        if (input instanceof Primitive) {
          tmp = mapPrimitive(input);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function mapArray(input) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = input.k2w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'mapArray.<anonymous>' call
      var tmp$ret$0 = new SdArrayValue_0(map(item.x2w_1), item.y2w_1);
      destination.e(tmp$ret$0);
    }
    var tmp$ret$3 = copyToArray(destination);
    return new SdArray(tmp$ret$3);
  }
  function mapPrimitive(input) {
    var tmp0_elvis_lhs = input.n2w_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return new SdPrimitive(null);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    if (value.d1b()) {
      tmp_0 = value.e1b();
    } else {
      var tmp1_elvis_lhs = get_intOrNull(value);
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_booleanOrNull(value) : tmp1_elvis_lhs;
      tmp_0 = tmp2_elvis_lhs == null ? get_doubleOrNull(value) : tmp2_elvis_lhs;
    }
    return new SdPrimitive(tmp_0);
  }
  function parseSdJwt$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(parseSdJwt$slambda$slambda).o2z = function (it, $completion) {
    var tmp = this.p2z(it, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(parseSdJwt$slambda$slambda).y9 = function (p1, $completion) {
    return this.o2z((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(parseSdJwt$slambda$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        if (tmp === 0) {
          this.w8_1 = 1;
          return JwsUtil_getInstance().r2a(this.n2z_1);
        } else if (tmp === 1) {
          throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(parseSdJwt$slambda$slambda).p2z = function (it, completion) {
    var i = new parseSdJwt$slambda$slambda(completion);
    i.n2z_1 = it;
    return i;
  };
  function parseSdJwt$slambda$slambda_0(resultContinuation) {
    var i = new parseSdJwt$slambda$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.o2z(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function parseSdJwt$slambda($sdJwtString, resultContinuation) {
    this.y2z_1 = $sdJwtString;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(parseSdJwt$slambda).a30 = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(parseSdJwt$slambda).y9 = function (p1, $completion) {
    return this.a30((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(parseSdJwt$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            var tmp_0 = Companion_instance_8;
            suspendResult = tmp_0.b2w(this.y2z_1, VOID, parseSdJwt$slambda$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var sdJwt = suspendResult;
            var this_0 = sdJwt.v2n_1;
            return new SdJwtParseResult(sdJwt.s2n_1, sdJwt.w2n_1, copyToArray(this_0), mapObject(sdJwt.u2n_1));
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(parseSdJwt$slambda).e2b = function ($this$promise, completion) {
    var i = new parseSdJwt$slambda(this.y2z_1, completion);
    i.z2z_1 = $this$promise;
    return i;
  };
  function parseSdJwt$slambda_0($sdJwtString, resultContinuation) {
    var i = new parseSdJwt$slambda($sdJwtString, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.a30($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function concealSdJwt$slambda$lambda($paths) {
    return function (path, _unused_var__etf5q3) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var this_0 = $paths;
        var tmp;
        if (isInterface(this_0, Collection)) {
          tmp = this_0.s();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.j();
        while (tmp0_iterator.k()) {
          var element = tmp0_iterator.l();
          // Inline function 'concealSdJwt.<anonymous>.<anonymous>.<anonymous>' call
          if (path.v2m(element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      return tmp$ret$0;
    };
  }
  function concealSdJwt$slambda($input, $pathsToConceal, resultContinuation) {
    this.j30_1 = $input;
    this.k30_1 = $pathsToConceal;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(concealSdJwt$slambda).p30 = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(concealSdJwt$slambda).y9 = function (p1, $completion) {
    return this.p30((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(concealSdJwt$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.m30_1 = JsToJsonConverter_instance.l28(this.j30_1);
            var tmp_0 = this;
            var this_0 = this.k30_1;
            var destination = ArrayList_init_$Create$(this_0.length);
            var inductionVariable = 0;
            var last = this_0.length;
            while (inductionVariable < last) {
              var item = this_0[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              destination.e(Companion_instance_5.o2m(item.slice()));
            }

            tmp_0.n30_1 = destination;
            var tmp_1 = this;
            var tmp0_elvis_lhs = createHashFunction('sha-256');
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              throw IllegalStateException_init_$Create$('Unable to create SHA-256 function');
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            var tmp_3 = tmp_2;
            tmp_1.o30_1 = new SdJwtConcealer('sha-256', tmp_3, concealSdJwt$slambda$lambda(this.n30_1));
            this.v8_1 = 1;
            suspendResult = this.o30_1.z2q(this.m30_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var this_1 = JsonToJsConverter_instance.m28(result.y2n_1);
            var this_2 = result.z2n_1;
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
            var tmp0_iterator = this_2.j();
            while (tmp0_iterator.k()) {
              var item_0 = tmp0_iterator.l();
              destination_0.e(item_0.f2l());
            }

            return new ConcealResult(this_1, copyToArray(destination_0));
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(concealSdJwt$slambda).e2b = function ($this$promise, completion) {
    var i = new concealSdJwt$slambda(this.j30_1, this.k30_1, completion);
    i.l30_1 = $this$promise;
    return i;
  };
  function concealSdJwt$slambda_0($input, $pathsToConceal, resultContinuation) {
    var i = new concealSdJwt$slambda($input, $pathsToConceal, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.p30($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  //region block: post-declaration
  protoOf(Property).g2l = toDisclosureHashString;
  protoOf(Value).g2l = toDisclosureHashString;
  protoOf($serializer).mz = typeParametersSerializers;
  protoOf($serializer_0).mz = typeParametersSerializers;
  protoOf($serializer_1).mz = typeParametersSerializers;
  protoOf($serializer_2).mz = typeParametersSerializers;
  protoOf($serializer_3).mz = typeParametersSerializers;
  protoOf($serializer_4).mz = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion();
  Companion_instance_2 = new Companion_0();
  Companion_instance_3 = new Companion_1();
  Companion_instance_4 = new Companion_2();
  AnyProperty_instance = new AnyProperty();
  AnyIndex_instance = new AnyIndex();
  Companion_instance_5 = new Companion_3();
  Companion_instance_6 = new Companion_4();
  Companion_instance_7 = new Companion_5();
  SdJwtKeyBindingBuilder_instance = new SdJwtKeyBindingBuilder();
  Companion_instance_8 = new Companion_6();
  Companion_instance_11 = new Companion_9();
  Companion_instance_12 = new Companion_10();
  Companion_instance_15 = new Companion_13();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.parseSdJwt = parseSdJwt;
    _.SdJwtParseResult = SdJwtParseResult;
    _.SdObject = SdObject;
    _.SdArray = SdArray;
    _.SdPrimitive = SdPrimitive;
    _.SdArrayValue = SdArrayValue_0;
    _.SdProperty = SdProperty_0;
    _.concealSdJwt = concealSdJwt;
    _.ConcealResult = ConcealResult;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_instance_6;
  _.$_$.b = SdJwtKeyBindingBuilder_instance;
  _.$_$.c = Companion_instance_8;
  _.$_$.d = $serializer_getInstance_0;
  _.$_$.e = JsonVcSdJwtIssuerMetadata;
  _.$_$.f = VcSdJwtIssuerJwtValidator;
  _.$_$.g = Array_0;
  _.$_$.h = Object_0;
  _.$_$.i = Primitive;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-sd-jwt.js.map
